import React, { useState } from 'react';
import { HEADER_WIDE_BOX_HANDICAP_TYPES } from '../data/constants';
import { classIf } from '../data/utils';


function HeaderUOBox(props) {
    const [selected, setSelected] = useState(null);

    // Imposta l'indice della scommessa associata all'handicap selezionato
    function handleClick(bet) {
        setSelected(bet);
        const type = `hcp-selection-${props.baseId}-${bet.id}`
        window.dispatchEvent(new CustomEvent(type, {detail: bet}));
    }

    const bet = props.selections[0];

    let forceWideBox = HEADER_WIDE_BOX_HANDICAP_TYPES.includes(bet.tipoHandicap);

    return (
        <div className={"d-flex justify-content-center align-items-center " + (forceWideBox === true ? "sposta-sb-nasc" : '')}>
            <button key={"hcp-header"} className={"bottone-apri-quote-dropdown dropdown-toggle text-uppercase bg-transparent bordo-tondo "+ (forceWideBox === true ? "bottone-quota-largo" : '')} type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <span className="uo-selezionato">{selected ? selected.handicapDesc : props.default}</span>
            </button>
            <div className="dropdown-menu quote-dropdown" data-associated-button={"hcp-header"}>
                {props.selections.map((bet, i) => {
                    return <a key={bet.uniqueId} className={"dropdown-item" + classIf(selected?.selectionId === bet.selectionId, 'selezionato')} onClick={() => handleClick(bet)}>{bet.handicapDesc}</a>
                })}
            </div>
        </div>
    );
}

export default HeaderUOBox;